import classNames from 'classnames';
import Link from 'components/ui/Link';
import { ContactFormModalTrigger } from 'compositions/ContactFormModal';
import { useTranslation } from 'hooks/useTranslation';
import { FC, ReactNode, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectUiState, setUi } from 'store/uiSlice';

type MiniMenuType = {
  trigger: ReactNode;
};

const MiniMenu: FC<MiniMenuType> = ({ trigger }) => {
  const dispatch = useAppDispatch();
  const ui = useAppSelector(selectUiState) || {};
  const translation = useTranslation();
  const [mouseOver, setMouseOver] = useState<boolean>(false);
  const linkClasses = 'cursor-pointer text-link';

  return (
    <div
      className="relative flex flex-row gap-6"
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="peer" onMouseOver={() => setMouseOver(true)}>
        {trigger}
      </div>
      <div
        className={classNames(
          'transition-all duration-300  ease-bounce ',
          mouseOver
            ? 'delay-75 scale-100 translate-x-0 pointer-events-auto opacity-100'
            : 'delay-500 scale-75 opacity-0 -translate-x-10 -translate-y-full hidden pointer-events-none',
        )}
      >
        <div className="flex flex-col bg-white rounded-md p-6 w-[200px] gap-3">
          <a
            className={linkClasses}
            onClick={() => {
              dispatch(
                setUi({
                  ...ui,
                  showOnboarding: ui?.showOnboarding
                    ? !ui?.showOnboarding
                    : true,
                }),
              );
            }}
          >
            {translation('onboarding.openGuide')}
          </a>
          <a
            className={linkClasses}
            onClick={() => {
              dispatch(
                setUi({
                  ...ui,
                  dashboard: {
                    ...ui?.dashboard,
                    lightingKnowledge: {
                      status: 'open',
                    },
                  },
                }),
              );
            }}
          >
            {translation('room.controls.lightingKnowledge')}
          </a>
          <ContactFormModalTrigger
            trigger={{
              type: 'link',
              className: linkClasses,
              text: translation('general.showContactForm'),
            }}
          />
          <Link
            className=""
            link={{
              text: translation('contactSupport'),
              url: 'mailto:support.recipe-of-light@fagerhult.se',
              target: '_blank',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MiniMenu;
